var dyn_account_exists = {
	title: "Account already exists"
};
var dyn_active_wallet_info = {
	testnet_warning: "A testnet network has been selected. Please only use testnet funds or they will be lost."
};
var dyn_chainalysis_blocked_wallet = {
	title: "Access denied"
};
var dyn_connect_button = "Connect your wallet";
var dyn_login = {
	connect_wallet: {
		title: "Connect"
	},
	qr_code: {
		title: "Connect"
	},
	sign_wallet: {
		title: "Sign"
	},
	wallet_group: {
		title: "Select Chain"
	},
	helper: {
		all_wallet_list: "Get your first wallet",
		email_form: {
			invalid_email: "Invalid or incorrect email. Did you mistype it?"
		},
		pending_connect: {
			title: "Connecting a wallet"
		},
		pending_signature: {
			title: "Signing a wallet"
		},
		pending_signature_without_back_button: {
			title: "Signing a wallet"
		},
		qr_code: {
			title: "Connecting a wallet"
		},
		wallet_only: "Get your first wallet"
	},
	separators: {
		"default": "OR"
	},
	title: {
		all: "Log in or Sign up",
		all_wallet_list: "Select your wallet",
		wallet_only: "Select your wallet"
	},
	wallet_list: {
		button_only: "Continue with a wallet"
	}
};
var dyn_network_not_supported = {
	button: "Switch Network",
	subtitle: "Your wallet is not connected to a supported network. Please update before continuing.",
	title: "Update Network",
	warning_message: "This network is not available, please update."
};
var dyn_network_not_supported_manual_switch = {
	subtitle_network_defined: "To continue, please update the network in your wallet to {{network}}",
	subtitle_no_network_defined: "Your wallet does not support switching networks from this app. Switch networks directly in your wallet.",
	title: "Update your Network",
	warning_message: "This network is not available, please update."
};
var dyn_no_access = {
	title: "You don't have access"
};
var dyn_passkey_intro = {
	button: "Set up a Passkey",
	button_logout: "Log out",
	disabled: "Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue",
	helper: {
		section_1: {
			description: "Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.",
			title: "Built by Apple and Google"
		},
		section_2: {
			description: "Passkeys are stored on your phone and are not shared with anyone.",
			title: "Secure and Private"
		},
		title: "What's Passkey",
		tooltip: "Need some help?"
	},
	subtitle: "We use Passkeys to keep your account safe. Passkeys are stored natively on your phone and cannot be accessed by anyone besides you.",
	title: "Secure your account"
};
var dyn_sign_message = {
	cancel_button: "Cancel",
	sign_button: "Sign",
	title: "Requesting Signature"
};
var dyn_wallet_conect = {
	mobile: {
		wallet_list: {
			helper: "Get your first wallet",
			title: "WalletConnect wallets"
		}
	}
};
var dyn_wallet_link = {
	cannot_link: {
		cancel_button: "Cancel",
		description: "This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.",
		link_other_button: "Link a different wallet",
		title: "Cannot link this wallet to a new account"
	}
};
var dyn_wallet_list = {
	helper: "Get your first wallet",
	title: {
		connect: "Connect a new wallet",
		link: "Link a new wallet",
		select: "Select your wallet"
	},
	view_all: "View all wallets"
};
var dyn_wallet_transfer = {
	sign: {
		title: "Sign to confirm transfer"
	}
};
var dyn_widget = {
	connect: "Connect your wallet",
	empty_wallets: "{{action}} additional wallets to see them here.",
	other_wallets: "My other wallets"
};
var sdkTranslation = {
	dyn_account_exists: dyn_account_exists,
	dyn_active_wallet_info: dyn_active_wallet_info,
	dyn_chainalysis_blocked_wallet: dyn_chainalysis_blocked_wallet,
	dyn_connect_button: dyn_connect_button,
	dyn_login: dyn_login,
	dyn_network_not_supported: dyn_network_not_supported,
	dyn_network_not_supported_manual_switch: dyn_network_not_supported_manual_switch,
	dyn_no_access: dyn_no_access,
	dyn_passkey_intro: dyn_passkey_intro,
	dyn_sign_message: dyn_sign_message,
	dyn_wallet_conect: dyn_wallet_conect,
	dyn_wallet_link: dyn_wallet_link,
	dyn_wallet_list: dyn_wallet_list,
	dyn_wallet_transfer: dyn_wallet_transfer,
	dyn_widget: dyn_widget
};

export { sdkTranslation as default, dyn_account_exists, dyn_active_wallet_info, dyn_chainalysis_blocked_wallet, dyn_connect_button, dyn_login, dyn_network_not_supported, dyn_network_not_supported_manual_switch, dyn_no_access, dyn_passkey_intro, dyn_sign_message, dyn_wallet_conect, dyn_wallet_link, dyn_wallet_list, dyn_wallet_transfer, dyn_widget };
